package pl.decks.chartjs.silk.radar

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.silk.theme.SilkTheme
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.border
import com.varabyte.kobweb.silk.theme.colors.palette.color
import pl.decks.chartjs.radar.RadarConfig

@Composable
fun SilkyRadarChart(
    canvasId: String,
    config: RadarConfig,
    modifier: Modifier = Modifier,
) {
    val colorMode = ColorMode.current
    val palette = SilkTheme.palette

    val defaults = SilkRadarDefaults(
        gridColor = palette.border.toRgb().copyf(alpha = 0.5f),
        tickColor = palette.color.toRgb().copyf(alpha = 0.5f),
        angleLinesColor = palette.border,
        pointLabelColor = palette.color,
        backdropColor = Color.rgba(0, 0, 0, 0f),
        legendLabelColor = palette.color,
        chartBackgroundColor = Color.rgba(0, 0, 0, 0f),
    )

    val silkConfig = remember(colorMode, config) {
        config.withSilkDefaults(defaults)
    }

    RadarChart(canvasId, config = silkConfig, modifier = modifier)
}
